import queryString from 'query-string'

import { isClient } from '@cred/shared/utils'

const ERROR_MESSAGE =
  '[CREDIBLE WIDGET INIT ERROR] - no widget_id provided. \n Customization, logging and any addons are currently unsupported'

const getIframeId = (logger) => {
  if (!isClient()) {
    return null
  }

  try {
    const { widget_id } = queryString.parse(window.location.search)
    if (!widget_id) {
      throw Error()
    }
    return widget_id
  } catch (e) {
    logger.error(ERROR_MESSAGE)
    console.warn(ERROR_MESSAGE)
    return null
  }
}
export default getIframeId
